import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ROLES } from 'src/app/authorization/registration/registration.component';
import { User } from 'src/app/core/objects/user';
import { UserApiService } from 'src/app/core/services/user-api.service';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { isMatchingControl } from 'src/app/shared/validators/validators';

@Component({
    selector: 'gl-external-user-popup',
    templateUrl: './external-user-password-popup.component.html',
    styleUrls: ['./external-user-password-popup.component.scss'],
    standalone: false
})
export class ExternalUserPasswordPopupComponent {
  public form: CustomForm;
  public user: User;
  public roles: string[] = ROLES;

  constructor(
    private modalRef: ModalOverlayRef,
    private userApiService: UserApiService,
  ) {
    this.form = this.generateForm();
  }

  public close(whatChange?: string): void {
    this.modalRef.close(whatChange);
  }

  public onSubmit(): void {
    if (this.form.valid) {
      const dateUpdate = {
        newPassword: this.form.value.password ? this.form.value.password : undefined,
        repeatedNewPassword: this.form.value.retypedPassword
          ? this.form.value.retypedPassword
          : undefined,
      };
      this.userApiService
        .updateUserInfo(dateUpdate)
        .subscribe(() => (dateUpdate.newPassword ? this.close('newPassword') : this.close()));
    }
  }

  private generateForm(): CustomForm {
    const form: UntypedFormGroup = new UntypedFormGroup({});
      const password: UntypedFormControl = new UntypedFormControl(null, [Validators.minLength(6), Validators.required]);
      const repeatedPassword: UntypedFormControl = new UntypedFormControl(null, [
        Validators.required,
        isMatchingControl(password),
      ]);
      form.addControl('password', password);
      form.addControl('retypedPassword', repeatedPassword);
    return form;
  }
}

interface CustomForm extends UntypedFormGroup {
  value: {
    email?: string;
    role?: string;
    password?: string;
    retypedPassword: string;
    acceptedTermsOfServiceAndPrivacyPolicy: string;
  };
}
